import { InputByTypeProperties } from "./form-builder-interface";
import { type DynamicStepComponentProperties } from "./dynamic-stepper-interface";

export type ConfirmableFieldAlias = 'email' | 'phone'| 'login' | 'accountId';
export const CONFIRMABLE_FIELDS_ALIASES: ConfirmableFieldAlias[] = ['email', 'phone', 'login', 'accountId'];
export interface OtpHeader {
  'x-otp-check': string;
}

export interface ConfirmationResult {
  field: ConfirmableFieldAlias;
  value: string;
  otpHeader: OtpHeader;
}

export type FieldConfirmationProps = {
  alias: ConfirmableFieldAlias,
  value?: string,
  updateProfile?: boolean,
  resetMode?: boolean,
  fieldError?: boolean,
  loading?: boolean,
  inputProperties?: InputByTypeProperties,
  optionalConfirm?: boolean,
  conditionalConfirm?: boolean,
  noSendImmediately?: boolean,
  /** Raw text shown while resend timer is counting. Use {0} as placeholder for seconds. Defaults to localized string. */
  textRetryIn?: string,
  /** Raw text for the resend link shown after timer ends. Defaults to localized string. */
  textRetryNow?: string,
} & DynamicStepComponentProperties;
